// extracted by mini-css-extract-plugin
export default {"container":"Go-z","bubbleNav":"Ho-z","graphic":"Io-z","contact":"Jo-z"};